<template>
    <div class="modal-header" style="border-bottom: 1px solid #e9ecef;align-items: center;">
        <button
            type="button"
            class="btn btn-sm g-btn-icon g-btn-ui g-btn-ui-secondary modal-close custom-close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeCallback()"
        >
            <svg class="ico-delete" aria-hidden="false" focusable="false">
                <use href="#ico-delete" xlink:href="#ico-delete" />
            </svg>
            <span>{{ $t("modals.close") }}</span>
        </button>
        <h1 class="modal-title">{{ $t("sign.title") }}</h1>
    </div>
</template>


<script>

    export default {
        name: 'SignHeader',

        props: {
            closeCallback: Function
        }
    }

</script>